import { render } from "./Timer.vue?vue&type=template&id=2243a7e3&scoped=true&ts=true"
import script from "./Timer.vue?vue&type=script&lang=ts"
export * from "./Timer.vue?vue&type=script&lang=ts"

import "./Timer.vue?vue&type=style&index=0&id=2243a7e3&scoped=true&lang=css"

import exportComponent from "/root/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2243a7e3"]])

export default __exports__